<template>
  <article class="bus_list_wrap home">
    <header class="pages_title">
      <div class="myHeader flexContainer">
        <div class="myHeaderL" @click="$router.go(-1);">
          <i class="iconfont_new icon-Left"></i>
        </div>
        <div class="myHeader textalignM" @click="changeSetDate">{{ setDate }}</div>
        <div class="myHeaderR textalignR"></div>
      </div>
    </header>

    <section class="pages_content">
      <ul
        style="padding:0.2rem;"
        :class="isCompleted ? 'tickets_wrap changeheight_show' : 'tickets_wrap changeheight_hide'"
      >
        <template
          v-for="(item, key, index) in frequencyList"
          v-if="item.isShow && (frequencyList && frequencyList.length > 0)"
        >
          <li
            class="ticket flex_wrap a_i_center j_c_between"
            v-if="item.timeOut"
            @click="chooseFrequency(item, index)"
            :key="key"
          >
            <div class="select_icon">
              <i :class="item.checked ? 'iconfont icon-xuanze' : 'iconfont icon-xuanze1'"></i>
            </div>
            <div style="width:2rem;">
              <div class="time">{{ item.time }}</div>
              <div v-if="item.pickupTimeOut && item.IsPickup">
                <span class="num primaryColor-text">接送服务</span>
              </div>
              <div v-else-if="item.FrequencyModel == '加班'">
                <span class="num primaryColor-text">加班车</span>
              </div>
            </div>
            <div>
              <div class="name">{{ item.placeList[0].PlaceName }}</div>
              <div class="name">{{ item.placeList[item.placeList.length - 1].PlaceName }}</div>
            </div>
            <div>
              <i class="iconfont icon-zhuanxiang1"></i>
            </div>
            <div>
              <div class="flight-number textalignR" style="margin-top:0;">
                <span class="fontSize35 color3 fontWeightChang">会员价</span>
                <dfn>¥</dfn>
                <strong>{{ item.PlacePriceList[0].AdultPrice }}</strong>
              </div>
              <div class="flight-number textalignR" style="margin-top:0;">
                <span class="fontSize35 color3 fontWeightChang">常规价</span>
                <dfn>¥</dfn>
                <strong>{{ item.PlacePriceList[0].AdultPrice }}</strong>
              </div>
              <div
                class="flight-shengyu"
              >余位{{ item.MaxMember - item.NowMember > 9 ? '>9' : item.MaxMember - item.NowMember }}</div>
              <div class="flight-tujing" @click.stop="showPlaceView(item, index)">
                途径站点
                <i class="iconfont icon-xiala primaryColor-text noticonreversal"></i>
              </div>
            </div>
            <!--途径-->
            <div :class="item.showView ? 'by_site show' : 'by_site'">
              <template v-for="(placeItem, keyword, idx) in item.placeList">
                <span :key="'by_site' + keyword">{{ placeItem.PlaceName }}</span>
                <i
                  :key="'by_site' + keyword"
                  class="iconfont icon-jiantou_qiehuanyou iconreversal"
                  v-if="idx < item.placeList.length - 1"
                ></i>
              </template>
            </div>
          </li>
        </template>
      </ul>
      <footer>
        <div class="tips_wrap" v-if="isCompleted">
          <p>
            <span class="red-text">温馨提示 :</span>
            <span>{{ frequencyMsg }}</span>
          </p>
          <p v-if="isShowShenzhentips">
            <span>凡购买中山候机楼至深圳北汽车站联!!!</span>
          </p>
        </div>
        <div class="flexContainer" style="margin-top:0.8rem;" v-if="isCompleted">
          <div class="flexItem1" style="padding:0.2rem 1rem;">
            <div class="queryConditionsButton textalignM" @click="showOrderPage">下一步</div>
          </div>
        </div>
      </footer>
    </section>
  </article>
</template>

<script>
import baseTool from "../utils/baseFunction";
import frequencyApi from "../request/frequencyApi";
import { mapState } from "vuex";
export default {
  name: "ChooseFrequencyList",
  data() {
    return {
      frequencyList: [],
      modelId: 0,
      avableShowFrequencyTime: "",
      avableShowPickupFrequencyTime: "",
      isCompleted: false,
      selectedFrequency: null,
      setDate: "",
      frequencyMsg: "",
      isShowShenzhentips: false,
      isNotRecord: false,
      buyMode: 0, // 0:候机楼车票$store.ticket    1:中山港船票$store.boat

      nowAfterThreeHour: "", // 现在后延3小时的时间

      // 2020-7-17 新增免费车票选座
      isFreeTicket: false, // 是否为免费车票，默认false
      flightOrderNum: "", // 航空机票订单号
    };
  },
  computed: mapState({
    GetType: (state) => state.ticket.GetType,
  }),
  activated() {
    console.log(this.$route.params.mode);
    let that = this;
    if (
      this.$route.params.mode != null ||
      this.$route.params.mode != undefined
    ) {
      this.buyMode = this.$route.params.mode;
      // ContactList = [];
      this.frequencyList = [];
      this.modelId = 0;
      this.avableShowFrequencyTime = "";
      this.avableShowPickupFrequencyTime = "";
      this.isCompleted = false;
      this.setDate =
        this.buyMode == 0 || this.buyMode == 2
          ? this.$store.state.ticket.SetDate
          : this.$store.state.boat.SetDate;
      this.$nextTick(function () {
        that.computedAvableTime();
        that.getFrequencyList();
      });
      wx.getLocation({
        type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: (res) => {
          let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          let speed = res.speed; // 速度，以米/每秒计
          let accuracy = res.accuracy; // 位置精度
          that.$store.commit("user/setLocation", longitude + "," + latitude);
        },
      });
    } else {
      this.$Message.warning("非法进入页面！");
    }
  },
  methods: {
    computedAvableTime() {
      let that = this;
      this.avableShowFrequencyTime = baseTool.formatterDateTime(new Date());
      let todayTenHour = baseTool.formatterDate(new Date()) + " 9:50";
      let todayAfterSixHour = baseTool.formatterDate(new Date()) + " 17:30";
      let todayAfter22Hour = baseTool.formatterDate(new Date()) + " 22:00";
      let nowTime = baseTool.formatterDateTime(new Date());

      // nowTime=2018-11-12 15:04比较todayTenHour=2018-11-12 10:00 false
      let IsTenBefore = baseTool.compareDateEndTimeGTStartTime(
        nowTime,
        todayTenHour
      ); // 当天10点前 true
      let IsSixteenBefore = baseTool.compareDateEndTimeGTStartTime(
        nowTime,
        todayAfterSixHour
      ); // nowTime=2018-11-12 15:04比较todayAfterSixHour=2018-11-12 18:00 true
      let Is22Before = baseTool.compareDateEndTimeGTStartTime(
        nowTime,
        todayAfter22Hour
      ); // 晚上10点前 true
      let after3hour = baseTool.addHour(new Date(), 3);

      if (IsTenBefore) {
        // 仍然未过当天10点，显示10点后3小时后的班车
        // this.data.avableShowPickupFrequencyTime = app.formatterDate(new Date()) + " 10:00";
        // 显示10点开始3小时后的接送
        let IsPlus3BeforeTen = baseTool.compareDateEndTimeGTStartTime(
          after3hour,
          todayTenHour
        );
        console.log(IsPlus3BeforeTen);
        if (IsPlus3BeforeTen) {
          this.avableShowPickupFrequencyTime =
            baseTool.formatterDate(new Date()) + " 9:50";
        } else {
          this.avableShowPickupFrequencyTime = after3hour;
        }
      }

      if (!IsTenBefore && IsSixteenBefore) {
        this.avableShowPickupFrequencyTime = after3hour;
      }

      if (!IsTenBefore && !IsSixteenBefore) {
        this.avableShowPickupFrequencyTime =
          baseTool.addDate(new Date(), 1) + " 7:00";
      }
      if (!IsTenBefore && !Is22Before) {
        this.avableShowPickupFrequencyTime =
          baseTool.addDate(new Date(), 1) + " 9:50";
      }

      // if (IsTenBefore) {
      // 	// 仍然未过当天10点，则下午1点以后的所有班次都可以显示
      // 	this.avableShowPickupFrequencyTime = baseTool.formatterDate(new Date()) + ' 13:00';
      // } else if (IsSixteenBefore) {
      // 	// 仍然未过当天下午6点，则可以查看隔天的全部接送班次，当天则不可以。
      // 	this.avableShowPickupFrequencyTime = baseTool.addDate(new Date(), 1) + ' 01:00';
      // } else {
      // 	this.avableShowPickupFrequencyTime = baseTool.addDate(new Date(), 1) + ' 13:00';
      // }
    },
    getFrequencyList() {
      this.$Spin.show();
      frequencyApi
        .getFrequencyList(
          this.buyMode == 0 || this.buyMode == 2
            ? this.$store.state.ticket.GetOn
            : this.$store.state.boat.GetOn,
          this.buyMode == 0 || this.buyMode == 2
            ? this.$store.state.ticket.GetOff
            : this.$store.state.boat.GetOff,
          this.buyMode == 0 || this.buyMode == 2
            ? this.$store.state.ticket.SetDate
            : this.$store.state.boat.SetDate,
          this.buyMode == 0 || this.buyMode == 2
            ? this.$store.state.ticket.SetTime
            : this.$store.state.boat.SetTime
        )
        .then((sucRes) => {
          if (sucRes.success && sucRes.data.length > 0) {
            this.modelId = sucRes.data[0].ModelID;
            this.getPlaceList(this.modelId, sucRes.data);
          } else {
            this.$Message.warning(
              "暂时无相关线路班次，可更改出发日期再次查询。"
            );
            this.$Spin.hide();
          }
        });
    },
    getPlaceList(ModelID, tmpFrequencyList) {
      let that = this;
      frequencyApi.getModelPlaceList(ModelID).then((sucRes) => {
        tmpFrequencyList.forEach((obj) => {
          obj.placeList = sucRes.data;
          obj.showView = false;
          obj.checked = false;
          obj.isShow = true;
          obj.SetDate = baseTool.formatDateStr(obj.SetDate, "date");
          obj.time = baseTool.formatDateStr(obj.SetTime, "time");
          obj.timeOut = baseTool.compareDateEndTimeGTStartTime(
            that.avableShowFrequencyTime,
            baseTool.formatDateStr(obj.SetTime, "full")
          );
          obj.pickupTimeOut = baseTool.compareDateEndTimeGTStartTime(
            that.avableShowPickupFrequencyTime,
            baseTool.formatDateStr(obj.SetTime, "full")
          );
          if (obj.timeOut) {
            that.isNotRecord = false;
          }
        });
        that.frequencyList = tmpFrequencyList;
        that.$Spin.hide();
      });
    },
    chooseFrequency(item, index) {
      let that = this;
      let checked = !item.checked;
      item.checked = !item.checked;
      this.frequencyList[index] = item;
      this.setFrequencyHideShow(item);
    },
    // 根据当前选择线路，隐藏其余同模板的线。
    setFrequencyHideShow(frequency) {
      let that = this;
      let isCompleteValue = false;
      if (frequency.checked) isCompleteValue = true;
      else isCompleteValue = false;

      for (let i = 0; i < this.frequencyList.length; i++) {
        if (
          frequency.checked &&
          this.frequencyList[i].ModelID == frequency.ModelID &&
          this.frequencyList[i].ID != frequency.ID
        ) {
          // 选中，则其余线隐藏
          this.frequencyList[i].isShow = false;
        } else if (
          !frequency.checked &&
          this.frequencyList[i].ModelID == frequency.ModelID &&
          this.frequencyList[i].ID != frequency.ID
        ) {
          this.frequencyList[i].isShow = true;
        }
      }
      this.selectedFrequency = frequency;
      this.isCompleted = isCompleteValue;
      this.setFrequencyMsg(frequency);
    },
    setFrequencyMsg(frequency) {
      this.frequencyMsg = "";
      this.isShowShenzhentips = false;
      var that = this;
      this.frequencyMsg =
        frequency.LineName +
        "班次乘车时长约为" +
        frequency.TotalMinute +
        "分钟；";
    },
    showPlaceView(frequency, index) {
      frequency.showView = !frequency.showView;
      this.frequencyList[index] = frequency;
    },
    showOrderPage() {
      let that = this;
      if (this.buyMode == 0) {
        this.$store.commit("ticket/setBaseTicketCondition", {
          SelectedFrequency: [this.selectedFrequency],
        });
        this.$router.push({
          name: "MakeTicketOrder",
          params: {
            mode: that.buyMode,
          },
        });
      } else if (this.buyMode == 1) {
        this.$store.commit("ticket/setBaseBoatCondition", {
          SelectedFrequency: [this.selectedFrequency],
        });
        this.$router.push({
          name: "MakeTicketOrder",
          params: {
            mode: that.buyMode,
          },
        });
      } else if (this.buyMode == 2) {
        this.$store.commit("ticket/setBaseTicketCondition", {
          SelectedFrequency: [this.selectedFrequency],
        });
        this.$router.go(-1);
      }
    },
    changeSetDate() {
      var that = this;
      this.$weui.datePicker({
        start: new Date(), // 从今天开始
        end: baseTool.addDate(new Date(), 60),
        onConfirm: (result) => {
          that.setDate =
            result[0].value +
            "-" +
            (result[1].value < 10 ? "0" + result[1].value : result[1].value) +
            "-" +
            (result[2].value < 10 ? "0" + result[2].value : result[2].value);

          if (that.buyMode == 0) {
            that.$store.commit("ticket/setBaseTicketCondition", {
              SetDate: that.setDate,
            });
          } else {
            that.$store.commit("boat/setBaseBoatCondition", {
              SetDate: that.setDate,
            });
          }
          // that.setDate = result[0].value + '-' + result[1].value + '-' + result[2].value;
          that.getFrequencyList();
        },
      });
    },
  },
};
</script>

<style lang="less" scoped="scoped">
@import "../style/public";
@import "../style/home.less";
.pages_title {
  background-color: transparent;
  padding: 0;
  color: #fff;
  border-bottom: none;
}
.tickets_wrap {
  transition: all 0.3s;
  overflow: auto;
}
.ticket {
  overflow: hidden;
  box-shadow: 0 0 5px #888;
  .flex_wrap(space-between, center, wrap);
  .bus_num,
  .bus_stop {
    .flex_wrap(space-around, center, initial, column);
  }
  margin-bottom: 0.25rem;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 0.3rem;
  border-radius: 0.15rem;
  background-color: #ffffff;
}

.ticket > div {
  /*padding: 0;*/
  font-size: 0.35rem;
  text-align: center;
  flex: none;
}
.select_icon {
  font-size: 0.6rem !important;
  border-right: 1px dashed #999999;
  align-self: stretch;
  display: flex;
  align-items: center;
  padding: 0 0.5%;
}
.select_icon > .iconfont {
  color: #006535;
  margin: 0 2px;
}
.bus_num {
  /*position: relative;*/
  /* flex: 0 1 20% !important; */
  padding: 0 0.5%;
  align-self: stretch;
}
.remain_seat i.iconfont.icon-yuyueruchang {
  font-size: 0.35rem;
  margin: 0;
  flex: 1 1 100%;
  /*position: absolute;*/
  /*text-align: center;*/
  /*transform: rotate(30deg);*/
}
.bus_num > .time {
  font-size: 0.45rem;
  font-weight: 400;
}
.bus_num > .num {
  font-size: 0.3rem !important;
  position: relative;
  text-align: center;
  width: 1.8rem;
  border-radius: 5px;
  background-color: #006535;
  color: #fff;
  margin-bottom: 5px;
  letter-spacing: 1px;
  line-height: 0.5rem;
  padding: 0 0.15rem;
}
.bus_num > .num > .iconfont {
  color: yellow;
  text-shadow: 0 0 1px #2578a4;
  margin: 0 0 0 2px;
  /*font-size: 1rem;*/
  position: absolute;
  top: 0;
  left: 2px;
}

.bus_stop {
  position: relative;
}
.bus_stop > span {
  width: 5em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
  line-height: 2em;
}
.bus_stop > .iconfont {
  position: absolute;
  right: -0.5em;
  font-weight: 600;
  color: #000;
}

.ticket_price,
.remain_seat,
.remaining_seats,
.by_site {
  font-size: 0.3rem !important;
}
.ticket_price,
.remain_seat {
  position: relative;
  /* margin-left: .4em; */
}
.ticket_price {
  font-weight: 600;
}
.ticket_price > span {
  display: block;
}
.remain_seat {
  text-align: center;
  flex-wrap: wrap;
  /*align-self: stretch;*/
  flex: 0 1 10% !important;
}
.remaining_seats {
  padding: 0 0.5%;
  .flex_wrap(center, center, initial, column);
}

.by_site {
  flex: 0 0 100% !important;
  line-height: 4vh;
  height: 0;
  overflow: hidden;
  transition: all 0.3s;
}
.by_site.show {
  height: 4vh !important;
}
.tips_wrap {
  font-size: 0.35rem;
  padding: 0.2rem 0.5rem;
  border-width: 1px 0;
  margin-bottom: 2px;
  background: #ffffff;
}
.num {
  background: #006535;
  color: #ffffff;
  padding: 0 0.1rem;
  font-size: 0.3rem !important;
  border-radius: 0.1rem;
}
.time {
  font-size: 0.5rem !important;
  line-height: 0.6rem;
  color: #333333;
}
.name {
  font-size: 0.35rem;
  color: #333333;
  line-height: 0.8rem;
}
.show {
  border-top: 1px solid #eaeaea;
  margin-top: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ChooseFrequencyList.vue